"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LongTextColumn;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _index = require("~/models/index");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let LongTextColumn = class LongTextColumn {
    static castType(data) {
        return data;
    }
    static async _insert(context, longTextColumn, props, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(longTextColumn, [
            'fk_workspace_id',
            'base_id',
            'fk_model_id',
            'fk_column_id',
            ...props || []
        ]);
        const column = await _index.Column.get(context, {
            colId: insertObj.fk_column_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.fieldNotFound(insertObj.fk_column_id);
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LONG_TEXT, insertObj);
        return this.read(context, longTextColumn.fk_column_id, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_LONG_TEXT}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LONG_TEXT, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_LONG_TEXT}:${columnId}`, column);
        }
        return column ? this.castType(column) : null;
    }
    static async _update(context, columnId, longTextColumn, props, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(longTextColumn, [
            ...props || []
        ]);
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COL_LONG_TEXT, updateObj, {
            fk_column_id: columnId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.COL_LONG_TEXT}:${columnId}`, updateObj);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
